import { useTenant } from '@emerald-works-nova/auth'
import useGroup from './useGroup'
import { FREE, BROWSER, SUSPENDED } from '../services/cognito/userGroups'

const useGoogleAdsense = () => {
  const tenant = useTenant()
  const { isInGroup } = useGroup()

  // if google adsense isn't defined or enabled, we shouldn't show ads
  if (process.env.REACT_APP_GOOGLE_ADSENSE_ENABLED !== 'true') {
    console.debug('*** Google Adsense hook - NOT ENABLED')
    return false
  }

  // if we're not in the right tenant, we shouldn't see google adsense ads
  if (process.env.REACT_APP_GOOGLE_ADSENSE_TENANT_PK !== tenant.pk) {
    console.debug('*** Google Adsense hook - NOT VALID TENANT ID - GOT ', tenant.pk, ' EXPECTED ', process.env.REACT_APP_GOOGLE_ADSENSE_TENANT_PK)
    return false
  }

  // if we're not a free, browser or suspended user, we shouldn't see google adsense ads
  if (!isInGroup(FREE) && !isInGroup(BROWSER) && !isInGroup(SUSPENDED)) {
    console.debug('*** Google Adsense hook - NOT CORRECT USER GROUP')
    return false
  }

  // if we've got this far, we're good to show google adsense ads
  console.debug('*** Google Adsense hook - ENABLED, VALID TENANT ID, CORRECT USER GROUP - SHOWING AD(S)')
  return true
}

export default useGoogleAdsense
